import React from 'react';
import { hasWarehouseAccess } from '@/config/app';
import ClientGate from '@/router/ClientGate';
import StockPage from './StockPage';
import SkuPage from './SkuPage';
import OutboundListPage from './OutboundListPage';
import OutboundDetailPage from './OutboundDetailPage';
import PurchaseOrderListPage from './PurchaseOrderListPage';
import PurchaseOrderDetailPage from './PurchaseOrderDetailPage';

export { WAREHOUSE_PATHS } from './shared';

/** /warehouse/* is only for clients the backend enables the WMS API for. */
const gated = (page: React.ReactNode) => (
  <ClientGate allowed={hasWarehouseAccess}>{page}</ClientGate>
);

export const WarehouseStockPage = () => gated(<StockPage />);
export const WarehouseSkuPage = () => gated(<SkuPage />);
export const WarehouseOutboundListPage = () => gated(<OutboundListPage />);
export const WarehouseOutboundDetailPage = () => gated(<OutboundDetailPage />);
export const WarehouseInboundListPage = () =>
  gated(<PurchaseOrderListPage key="inbound" mode="inbound" />);
export const WarehouseInboundDetailPage = () =>
  gated(<PurchaseOrderDetailPage mode="inbound" />);
export const WarehousePurchaseOrderListPage = () =>
  gated(<PurchaseOrderListPage key="purchase-order" mode="purchase-order" />);
export const WarehousePurchaseOrderDetailPage = () =>
  gated(<PurchaseOrderDetailPage mode="purchase-order" />);
